module.exports = __webpack_public_path__ + "static/media/2021_Cadillac_XT6_ext_05_6NX26_1SF_GB8.602074ce.png";